import React from "react";

const OutcomesCard = ({ title, value, icon, currency }) => (
  <div className="text-center">
    <div
      className={`rounded-2xl text-white text-xl w-9 h-9 mx-auto my-1 flex items-center justify-center ${
        currency === "€" ? "bg-yellow-600" : "bg-teal-700"
      }`}
    >
      {icon}
    </div>
    <h5 className="text-xs m-0 text-gray-500 font-bold">{title}</h5>
    <h4 className="text-xl m-0 p-0 text-black font-bold text-balance">{value}</h4>
  </div>
);

const SME_TABLE_TABS = ["sme", "corporate", "social-enterprise", "sedf-enterprise"];

const TotalAllocatedSection = ({ activeSubTab, currentData }) => {
  const formatMillions = (num) =>
    `${(Number(num) || 0).toLocaleString("en-US", { maximumFractionDigits: 6 })} M`;

  return (
    <div className="lg:col-span-4">
      <div className="text-center mb-3">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Total Allocated
        </h3>
        <div className="grid grid-cols-2 gap-4 mt-3">
          {SME_TABLE_TABS.includes(activeSubTab) ? (
            <>
              <OutcomesCard
                title="Approved Amount (M) (PKR)"
                value={`₨ ${formatMillions(currentData?.totalAmountPkr)}`}
                icon="₨"
                currency="₨"
              />
              <OutcomesCard
                title="Approved Amount (M) (EUR)"
                value={`€ ${formatMillions(currentData?.totalAmountEuro)}`}
                icon="€"
                currency="€"
              />
            </>
          ) : (
            <>
              <OutcomesCard
                title="Cost Rationalization (M) (PKR)"
                value={`₨ ${formatMillions(currentData?.totalAmountPkr)}`}
                icon="₨"
                currency="₨"
              />
              <OutcomesCard
                title="Grant Asked Amount (M) (PKR)"
                value={`₨ ${formatMillions(currentData?.expectedAmountPkr)}`}
                icon="₨"
                currency="₨"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TotalAllocatedSection;
